
import Vue from 'vue'
import JcdcAlert from '@/components/jcdc/JcdcAlert.vue'

export default Vue.extend({
  name: 'JcdcSessionTimeout',
  components: { JcdcAlert },
  props: {
    appEnvironment: { type: String, default: 'production' },
  },
  data() {
    return {
      listenerEvents: [
        'click',
        'mousemove',
        'mousedown',
        'scroll',
        'keypress',
        'load',
      ],
      warningTimer: 0,
      logoutTimer: 0,
      countdown: 0,
      warningZone: false,
      warningTime: 14 * 60, // 14 minutes
      logoutTime: 15 * 60, // 15 minutes
      interval: 0,
    }
  },

  mounted() {
    // Listen for events listed above.
    this.listenerEvents.forEach((event) =>
      // Reset timers when event is triggered
      window.addEventListener(event, this.resetTimers)
    )
    // Adjust component timing
    if (this.appEnvironment === 'storybook') {
      // Shorten the time for testing the component -MN
      this.warningTime = 5 // 5 seconds
      this.logoutTime = 10 // 10 seconds
    } else if (this.appEnvironment !== 'production') {
      // Extend time for environments other than production
      this.warningTime = 50 * 60 // 50 minutes
      this.logoutTime = 60 * 60 // 60 minutes
    }
    this.setTimers()
  },
  destroyed() {
    // Clear event listeners and reset timers
    this.listenerEvents.forEach((event) =>
      window.removeEventListener(event, this.resetTimers)
    )
  },
  methods: {
    setTimers() {
      this.warningZone = false
      this.countdown = this.logoutTime - this.warningTime
      this.warningTimer = window.setTimeout(this.warn, this.warningTime * 1000)
      this.logoutTimer = window.setTimeout(this.logout, this.logoutTime * 1000)
    },
    resetTimers() {
      clearInterval(this.interval)
      clearTimeout(this.warningTimer)
      clearTimeout(this.logoutTimer)
      this.setTimers()
    },
    warn() {
      this.warningZone = true
      this.interval = window.setInterval(() => {
        this.countdown--
      }, 1000)
    },
    logout() {
      this.$emit('inactive-logout')
      this.resetTimers()
    },
  },
})
